// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "gateways-2-3Ez";
var _4 = "gateways_hidden-1Hi-L";
var _5 = "gateway__selector-cDwsK";
var _6 = "applepay-4FBWt";
var _7 = "googlepay-3wujM";
var _8 = "wrapper-3YhRI";
var _9 = "oneMethod-2G3en";
var _a = "details-3i5Xk";
var _b = "content-1miOD";
var _c = "timelimit-2qR6Y";
export { _1 as "__esModule", _2 as "mobile", _3 as "gateways", _4 as "gateways_hidden", _5 as "gateway__selector", _6 as "applepay", _7 as "googlepay", _8 as "wrapper", _9 as "oneMethod", _a as "details", _b as "content", _c as "timelimit" }
export default { "__esModule": _1, "mobile": _2, "gateways": _3, "gateways_hidden": _4, "gateway__selector": _5, "applepay": _6, "googlepay": _7, "wrapper": _8, "oneMethod": _9, "details": _a, "content": _b, "timelimit": _c }
